/* eslint-disable @typescript-eslint/no-explicit-any */
const Tipo = ({ setForm, form }: any) => {
  const tipo = [
    {
      name: "Actividad grupal",
      description: "",
    },
    {
      name: "Actividad individual",
      description: "",
    },
    {
      name: "Familiar exclusiva",
      description: "",
    },
  ];

  const onClick = (e: any, value: string) => {
    switch (e.target.name) {
      case "type":
        {
          setForm({
            ...form,
            space: value,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
        <div>
          <span className="font-bold text-black mb-2 block">
            ¿Qué tipo de alojamiento ofrecés a los huéspedes?
          </span>
          <div className="grid grid-cols-1 gap-5">
            {tipo.map((t) => {
              if (t.name == form.space) {
                return (
                  <label className="bg-gray-300 hover:bg-white-700 text-black font-bold py-4 px-4 shadow cursor-pointer "
                  style={{ borderRadius: "10px 10px 10px 10px" }}>
                    <span className="font-bold block">{t.name}</span>
                    <span className="block text-sm">{t.description}</span>
                    <button
                      className="hidden"
                      name="type"
                      onClick={(event) => onClick(event, t.name)}
                    ></button>
                  </label>
                );
              }

              return (
                <label className="bg-white-500 hover:bg-white-700 text-black font-bold py-4 px-4  shadow cursor-pointer "
                style={{ borderRadius: "10px 10px 10px 10px" }}>
                  <span className="font-bold block">{t.name}</span>
                  <span className="block text-sm">{t.description}</span>
                  <button
                    className="hidden"
                    name="type"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Tipo;
